import { Component, Input } from '@angular/core';
import {
  TableChartWidgetData,
  TableChartTab,
} from 'src/app/core/providers/dashboardWidget/dashboardWidget.models';
import { GenericTableComponent } from 'src/app/shared/generic-table/generic-table.component';

@Component({
  selector: 'app-table-chart',
  standalone: true,
  imports: [GenericTableComponent],
  templateUrl: './table-chart.component.html',
  styleUrl: './table-chart.component.scss',
})
export class TableChartComponent {
  @Input() widgetData!: TableChartWidgetData;

  get tabs(): TableChartTab[] {
    return this.widgetData?.tabs ?? [];
  }

  get selectedTab(): TableChartTab | undefined {
    return this.tabs[this.widgetData.selectedTabIndex ?? 0];
  }

  selectTab(idx: number) {
    this.widgetData.selectedTabIndex = idx;
  }
}
